import './App.css';
import UrlRoutes from './UrlRoutes';
import store from './Redux/Store';
import { Provider } from 'react-redux';
import ConfigureAmplifyClientSide from './Services/Cognito/cognito';

function App() {
  return (
    <Provider store={store}>
      <ConfigureAmplifyClientSide />
      <UrlRoutes />
    </Provider>
  );
}

export default App;
